import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { MAIN_MENUS } from '@app/dashboard/models/main-menu.model';
import { IAuthCheckQueryParams } from '@app/lib/models/auth-check.model';
import { ILoginData, ILoginResponse } from '@app/lib/models/login.model';

@Component({
  selector: 'app-auth-check',
  standalone: true,
  imports: [],
  template: ''
})
export class AuthCheckComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    console.log('AuthCheckComponent initialized.');

    // Extract query parameters directly
    this.route.queryParams.subscribe((queryParams) => {
      console.log('### Parsed Query Params:', queryParams);

      const token = queryParams['token'];
      console.log('### token:', token);

      //const menuId = Number(queryParams['menuid']); // Convert menuid to a number

      // Validate token and menuId
      if (!token)
      //  || isNaN(menuId) || menuId <= 0)
      {
        console.error('Invalid or missing token or menu ID:', {
          token,
          //  menuId
        });
        this.router.navigate(['/login']); // Redirect to login if invalid

        return;
      }


      console.log('### Token:', token);

      // Check if user data exists
      const userData = this.authService.getData();
      // Validate token and redirect
      if (userData && !this.authService.isTokenExpired(token)) {
        console.log('Valid token. Redirecting to menu ID:',
          // menuId
        );
        this.authService.storeToken(token, userData.refreshToken || ''); // Store token
        this.redirectToActiveMenu(); // Redirect to the appropriate menu
      } else {
        console.warn('Token expired. Authenticating...');
        this.authService.authCheck(token).subscribe({
          next: (res: ILoginResponse) => {
            if (res.loginData) {
              console.log('Authentication successful. Redirecting...');
              this.authService.setData({ ...res.loginData, token: res.token, refreshToken: res.refreshToken });
              this.authService.user.next({ ...res.loginData, token: res.token, refreshToken: res.refreshToken });
              this.authService.storeToken(res.token, res.refreshToken); // Store token after validation
              this.redirectToActiveMenu(); // Redirect after authentication
            } else {
              console.error('Authentication failed. Redirecting to login.');
              this.router.navigate(['/login']);
            }
          },
          error: (err) => {
            console.error('Authentication error:', err);
            this.router.navigate(['/login']);
          }
        });
      }
    });
  }


  private redirectToActiveMenu() {
    const userData = this.authService.getData() as ILoginData | null;

    // Check if user data is available
    if (!userData) {
      console.error('No user data available. Redirecting to login.');
      this.router.navigate(['/login']);
      return;
    }
    const activeMenus = this.getAuthorizedMenuList(userData);
    const routePath = ['/dashboard'];
    //if (activeMenus[menuid]) {
    //routePath.push(activeMenus[menuid].routerLink);
    //}
    this.router.navigate(routePath);
    //this.router.navigate(['/dashboard']);
  }

  private getAuthorizedMenuList(userData: ILoginData) {
    const allMenus = MAIN_MENUS;
    const allowedMenuList: { [key: string]: string } = {};
    (userData.menuDTOList || []).forEach(menuItem => {
      allowedMenuList[menuItem.menuDescription] = menuItem.menuDescription;
    });
    const allowedMenuIds = Object.keys(allowedMenuList);

    const authorizedMenus = allMenus.filter(mItem => {
      const isAllowed = allowedMenuIds.includes(mItem.id);
      if (isAllowed) {
        mItem.label = allowedMenuList[mItem.id];
      }
      return isAllowed;
    });
    // Print the authorized menus for debugging
    console.log('Authorized Menus:', authorizedMenus);

    return authorizedMenus;
  }

  private parseQueryParams(fragment: string): { [key: string]: string } {
    return fragment
      .split('&')
      .map(param => param.split('='))
      .reduce((acc, [key, value]) => {
        acc[key] = decodeURIComponent(value || '');
        return acc;
      }, {} as { [key: string]: string });
  }

}
